(function () {
  // Variables globales
  const productVariants = CurrentProduct;
  const templateName = CurrentTemplate;
  const selectedOptions = { color: null, size: null };
  const getUrl = window.location;
  const variantColorEls = document.querySelectorAll('.variant_color');
  const variantSizeEls = document.querySelectorAll('.variant_size');
  const colorSelectedEl = document.querySelector('.color-selected');
  const sizeSelectedEl = document.querySelector('.size-selected');
  const productSelectEl = document.querySelector('#ProductSelect');
  const addToCartBtn = document.querySelector('#AddToCartBtnBsl');
  const variantSeletedImg = document.querySelector('#gallery-section__image-selected');


  // Funtions
  async function addToCartClickHandler(event) {
    const bodyElement = document.querySelector('body');
    const drawerCart = document.querySelector('#drawer-cart-modal')
    event.preventDefault();
    const form = event.target.parentNode;
    const formData = new FormData(form);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      await response.json();
      liquidAjaxCart.update();
      bodyElement.style.overflow = 'hidden';
      drawerCart.classList.add('show-cart-modal');
      
    } catch (error) {
      console.log(error);
    }
  }

  waitForElement('.color-selected').then((elm) => {
    renderVariantImages(colorSelectedEl, "Color", '#gallery-section__images', true);
    renderVariantImages(colorSelectedEl, "Color", '#gallery-section__bullets', false);
  });
    
  function handleClick(event) {
    event.preventDefault();
  
    const button = event.currentTarget;
  
    const optionName = button.getAttribute('data-name');
    const optionValue = button.getAttribute('value');
    const onlyLeftInStock = document.querySelector('#only-left-in-stock');
  
    selectedOptions[optionName] = optionValue;
  
    const selectedVariant = getProductVariant(productVariants, selectedOptions);
  
    addRemoveClass(`.variant_${optionName}`, button, 'selected');
    updateSizeAvailability();
  
    if (selectedVariant) {
      colorSelectedEl.textContent = selectedVariant.options[0];
      sizeSelectedEl.textContent = cutTheTextContent(selectedVariant.options[1]);
      productSelectEl.value = selectedVariant.id;

      if (templateName === 'rebuild-1') {
        renderVariantImages(colorSelectedEl, button.dataset.swatch, '#gallery-section__images', true);
        renderVariantImages(colorSelectedEl, button.dataset.swatch, '#gallery-section__bullets', false);
      }
      if (optionName == 'color' || optionName == 'Color') {
        if (templateName === 'rebuild-3') filterGridImages(colorSelectedEl, button.dataset.swatch);
      }
  
      if (selectedVariant.inventory_quantity > 0 && selectedVariant.inventory_quantity <= 10) {
        onlyLeftInStock && onlyLeftInStock.classList.add('db', 'show-only-left');
        if (onlyLeftInStock != null) onlyLeftInStock.textContent = `${selectedVariant.inventory_quantity} left in stock for size: ${sizeSelectedEl.textContent}`;
      } else {
        onlyLeftInStock && onlyLeftInStock.classList.remove('db', 'show-only-left');
      }
  
      const variantUrl = getUrl.search.split('nosto=').pop();
      if (!variantUrl) {
        history.pushState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
      }
  
      const soldButton = document.querySelector('.sold-out-btn');
      const backInStock = document.querySelector('.pdp-klaviyo-trigger');
  
      if (selectedVariant.available) {
        UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
        let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');
  
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);  
          [...showComparePrice].forEach(item => {
            item.classList.remove('dn-i');
            item.closest('.info-product-detail__price').classList.add('product-price-strike-through')
          });
          
        } else {
          [...showComparePrice].forEach(item => item.classList.add('dn-i'));
        }
  
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('dn-i', 'disabled-add-to-cart');
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        soldButton.classList.add('dn-i');
        backInStock.classList.add('dn-i');
      } else {
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled-add-to-cart', 'dn-i');
        soldButton.classList.remove('dn-i');
        backInStock.classList.remove('dn-i');
      }
    }
  }
  
  function getProductVariant(product, selectedOptions) {
    const variantOptionCurrent = productSelectEl.selectedOptions[0].dataset.variantOptions.split('-');
    const colorSelected = selectedOptions.color || variantOptionCurrent.shift();
    const sizeSelected = selectedOptions.size || variantOptionCurrent.pop();
    const matchText = `${colorSelected} / ${sizeSelected}`;

    const selectedVariant = product.variants.find(variant => variant.title === matchText);
    UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
    let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');

      if (selectedVariant.compare_at_price > selectedVariant.price) {
          UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);  
          [...showComparePrice].forEach(item => item.classList.remove('dn-i'));
      }else{
          [...showComparePrice].forEach(item => item.classList.add('dn-i'));
      }

    return selectedVariant;
  }

  function setDefaultVariant() {
    const variantUrl = getUrl.search.split('?variant=').pop();
    const selectedOptions = document.querySelectorAll('.swatch-btn[selected]');
    const availableVariants = productSelectEl.querySelectorAll('option');

    if (variantUrl && [...availableVariants].some(v => v.value === variantUrl)) {
      productSelectEl.value = variantUrl;
      document.querySelector('.variant_size.selected') && document.querySelector('.variant_size.selected').click();
      history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${variantUrl}`);
    }
    if (selectedOptions) selectedOptions.forEach(option => option.click());

  }

  //Availables variants size
  function updateSizeAvailability() {
    const color = selectedOptions.color;
    const unavailableSizes = new Array();
    const availableSizes = new Array();

    variantSizeEls.forEach(sizeEl => {
      const sizeValue = sizeEl.getAttribute('value');
      const variant = getProductVariant(productVariants, { color: color, size: sizeValue });

      sizeEl.dataset.colorSelected = color;
      colorSelectedEl.dataset.colorSelected = color;
      availableSizes.push(sizeValue)
      if (variant && variant.available) {
        sizeEl.classList.remove('sold-out');
      } else {
        sizeEl.classList.add('sold-out');
        unavailableSizes.push(sizeValue);
      }

      sizeEl.textContent = cutTheTextContent(sizeEl.dataset.cuttext);
    });
  }
// Reusable function to show/hide variant images based on color
function renderVariantImages(selectedColor, isColorVariant, parentContainer, isDraggable) {
  const galleryImages = document.querySelector(parentContainer);
  const colorValue = selectedColor.dataset.colorSelected.replace(/ /g, '-');
  
  [...galleryImages.children].forEach((image, index) => {
    if (isDraggable) {
      draggableSlide('.gallery-section__images');
    }
    
    const isImageMatchingColor = image.dataset.colorSelected.includes(colorValue.toLowerCase());
    
    if (isImageMatchingColor) {
      image.classList.remove('dn-i');
      image.classList.add('db-images');
    } else {
      image.classList.add('dn-i');
      image.classList.remove('db-images');
    }
  });

  if (isColorVariant === 'Color') {
    return selectFirstImageAvailable([...galleryImages.children]);
  }
}



  function openCloseModal(close, modal, carouselContainer) {
    let modalContainer = document.querySelector(modal);
    let closeIcon = document.querySelector(close);

    closeIcon.addEventListener('click', () => {
      document.body.style.overflowY = 'auto';
      if ($(carouselContainer).hasClass('slick-initialized')) {
        $(carouselContainer).slick('unslick');
      }
      modalContainer.classList.remove('active');
    });
  }

  // Function to generate HTML for the image
  function generateHtmlZoomImg(imageSrc, imageSrcSet) {
    const parentImage = document.createElement('div');
    const image = document.createElement('img');
    image.src = imageSrc;
    if (imageSrcSet != undefined) image.srcset = imageSrcSet && imageSrcSet;

    image.classList.add('carousel-image'); // Add a CSS class for styling, if needed
    parentImage.appendChild(image);
    parentImage.classList.add('parent-image-item'); // Add a CSS class for styling
    return parentImage;
  }
  //Funtions to creare the gallery on Rebuild 1
  function selectFirstImageAvailable(Images) {
    const galleryGridSlide = document.querySelectorAll('.gallery-section__images-item');

    //Put first image available as Main Image default
    const result = Images.filter(image => image.classList.contains('db-images'));
    const firstImage = result[0];
    

    variantSeletedImg && [...variantSeletedImg.children].forEach((mainImage) => {
      mainImage.classList.add('dn-i', 'fade-in');
      mainImage.classList.remove('mainimage-selected');
      
      if (firstImage.dataset.imageId === mainImage.dataset.imageId) {
        mainImage.classList.remove('dn-i', 'fade-in');
        mainImage.classList.add('mainimage-selected');
        selectedImageActive('.gallery-section__images-item', '.gallery-section__bullets-item', mainImage.dataset.imageId);
        selectedImageActive('.gallery-section__bullets-item', '.gallery-section__images-item', mainImage.dataset.imageId);
      }

      requestAnimationFrame((timestamp) => {
        removeFadeInClass(timestamp, mainImage);
      });
    });

    [...galleryGridSlide].forEach((img) => {
      if (img.dataset.image === productSelectEl.value) {
        img.classList.add('selected-active');
      }
    });

  }
  arrowButtonsNextPrev()
  //Create arrow buttons to change the selected image
  function arrowButtonsNextPrev() {
    const prevButton = document.querySelector('.arrow--left-pdp');
    const nextButton = document.querySelector('.arrow--right-pdp');

    // Agrega un manejador de eventos para el botón "Next"
    nextButton.addEventListener('click', () => {
      let color = colorSelectedEl.textContent.replace(/ /g, '-').toLowerCase();
     
      currentImageIndex = (getIndexMainImageSelected(color).currentImageIndex + 1) % filterElementsByColor(color).length;
      selectImageNextPrev(currentImageIndex, filterElementsByColor(color));
      updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__images-item');
      updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__bullets-item');
    });

    // Agrega un manejador de eventos para el botón "Prev"
    prevButton.addEventListener('click', () => {
      let color = colorSelectedEl.textContent.replace(/ /g, '-').toLowerCase();
      currentImageIndex = (getIndexMainImageSelected(color).currentImageIndex - 1 + filterElementsByColor(color).length) % filterElementsByColor(color).length;
      selectImageNextPrev(currentImageIndex, filterElementsByColor(color));
      updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__images-item');
      updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__bullets-item');
    });

  }
  //Next and Previous buttons
  function selectImageNextPrev(index, images) {
    [...images].forEach((img, i) => {
      if (i === index) {
        img.classList.remove('dn-i');
        img.classList.add('mainimage-selected');
      } else {
        img.classList.add('dn-i', 'fade-in');
        img.classList.remove('mainimage-selected');
      }
    });
  }

  function createDraggableSlider() {
    let isDragging = false;
    let startX, currentX, deltaX;

    const dragBox = document.getElementById('gallery-section__image-selected');

    const handleMove = (x) => {

      if (isDragging) {
        currentX = x;

        if (isTouchDevice()) deltaX = currentX - startX;
        if (!isTouchDevice()) deltaX = currentX.x - startX;


        if (deltaX > 0) {
          let color = colorSelectedEl.textContent.replace(/ /g, '-').toLowerCase();
          currentImageIndex = (getIndexMainImageSelected(color).currentImageIndex - 1 + filterElementsByColor(color).length) % filterElementsByColor(color).length;
          selectImageNextPrev(currentImageIndex, filterElementsByColor(color));
          updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__images-item');
          updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__bullets-item');

        } else if (deltaX < 0) {
          let color = colorSelectedEl.textContent.replace(/ /g, '-').toLowerCase();
          currentImageIndex = (getIndexMainImageSelected(color).currentImageIndex + 1) % filterElementsByColor(color).length;
          selectImageNextPrev(currentImageIndex, filterElementsByColor(color));
          updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__images-item');
          updateImageSelectedSlider(getIndexMainImageSelected(color).mainImageSelected, '.gallery-section__bullets-item');

        }

        // Remove the event listeners once dragging is done
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      }
    };
    const handleMouseUp = () => {
      isDragging = false;
    };

    const handleTouchMove = (e) => {
      handleMove(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
      isDragging = false;
    };

    dragBox.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;

      // Add event listeners for mousemove and mouseup
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleMouseUp);
    });

    dragBox.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX; // Use e.touches[0].clientX for touch events

      // Add event listeners for touchmove and touchend
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleTouchEnd);
    });
  }

  // Call the function to make the slider draggable
  createDraggableSlider();

  function isTouchDevice() {
    if (navigator.maxTouchPoints > 0) return true;
    return false;
  }


  //Select image form slider bottom
  function updateImageSelectedSlider(imageSelected, items) {
    const images = document.querySelectorAll(items);
    let selectedImage = [...images].filter(img => img.dataset.imageId === imageSelected.dataset.imageId);

    //Select image
    [...images].forEach((img) => img.classList.remove('selected-active'));
    selectedImage[0].classList.add('selected-active');
  }

  function getIndexMainImageSelected(color) {
    let filteredImages = filterElementsByColor(color);
    let mainImageSelected = filteredImages.find(img => img.classList.contains('mainimage-selected'));
    let currentImageIndex = parseInt(filteredImages.indexOf(mainImageSelected));
    return { currentImageIndex, mainImageSelected };
  }


  //Filter images by color
  function filterElementsByColor(color) {
    return [...variantSeletedImg.children].filter(img => img.classList.value.includes(color));
  }
  //OpenModal for images selected

  let selectedImag = document.querySelectorAll('.gallery-section__main img');
  [...selectedImag].forEach((image) => {
    image.addEventListener('click', () => {
      let color = colorSelectedEl.textContent.replace(/ /g, '-').toLowerCase();
      filterSlickSLideImage(getIndexMainImageSelected(color).currentImageIndex, '.slide-zoom-image', '#slide-zoom-image', filterElementsByColor(color))

    })
  });


  //Slick slide modal images 
  function filterSlickSLideImage(slideIndex, container, carouselslick, images) {
    const carouselContainer = document.querySelector(container);
    const slickCarousel = document.querySelector(carouselslick);

    slickCarousel.innerHTML = '';

    images.forEach((image) => {
      let imageCarousel = generateHtmlZoomImg(image.getAttribute('src'), image.getAttribute('srcset'));
      slickCarousel.appendChild(imageCarousel);
    })
    // const featured_image = generateHtmlZoomImg(document.querySelector('.featured-image-rebuild').dataset.modalImg);
    // carouselContainer.appendChild(featured_image);

    $(document).ready(function () {
      $(slickCarousel).slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
      });
      $(slickCarousel).slick('slickGoTo', slideIndex);
    });
    carouselContainer.classList.add('active');
    openCloseModal('.close-zoom-image', '.slide-zoom-image', slickCarousel);
  }

  //Remove animations
  function removeFadeInClass(timestamp, element) {
    let startTime = null;
    const duration = 500; // Delay duration in milliseconds
    if (!startTime) {
      startTime = timestamp;
    }

    const elapsed = timestamp - startTime;

    if (elapsed < duration) {
      requestAnimationFrame((timestamp) => {
        removeFadeInClass(timestamp, element);
      });
    } else {
      element.classList.remove('fade-in');
    }
  }

  //Select the image selected
  function selectedImageActive(imageSelectors, syncSelectors, firstSelected) {
    const images = Array.from(document.querySelectorAll(imageSelectors));
    const syncItems = Array.from(document.querySelectorAll(syncSelectors));

    // Función para eliminar la clase 'selected-active' de todos los elementos
    function clearSelection() {
      images.forEach(image => image.classList.remove('selected-active'));
      syncItems.forEach(item => item.classList.remove('selected-active'));
    }

    // Función para manejar el clic en una imagen
    function handleImageClick(image) {
      clearSelection();

      const imageId = image.dataset.imageId;
      const syncItem = syncItems.find(item => item.dataset.imageId === imageId);

      if (syncItem) {
        syncItem.classList.add('selected-active');
        image.classList.add('selected-active');
      }

      [...variantSeletedImg.children].forEach(mainImage => {
        mainImage.classList.add('dn-i');
        mainImage.classList.remove('mainimage-selected');

        if (mainImage.dataset.imageId === imageId) {
          mainImage.classList.remove('dn-i');
          mainImage.classList.add('mainimage-selected');
        }

        requestAnimationFrame(timestamp => {
          removeFadeInClass(timestamp, mainImage);
        });
      });
    }

    // Agregar manejador de clic a cada imagen
    images.forEach(image => {
      image.addEventListener("click", () => {
        handleImageClick(image);
      });
    });

    // Activar la imagen inicial
    const firstImage = images.find(image => image.dataset.imageId === firstSelected);
    if (firstImage) {
      handleImageClick(firstImage);
    }
  }


function draggableSlide(container) {
  let isDown = false;
  let startX;
  let scrollLeft;
  const slider = document.querySelector(container);

  const end = () => {
    isDown = false;
    slider.classList.remove('active');
  };

  const start = (e) => {
    isDown = true;
    slider.classList.add('active');
    e.preventDefault();  // Prevenir comportamiento predeterminado en móviles
    const pageX = e.pageX || e.touches[0].pageX;
    startX = pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const move = (e) => {
    if (!isDown) return;

    e.preventDefault();  // Solo prevenir el comportamiento cuando se está arrastrando
    const pageX = e.pageX || e.touches[0].pageX;
    const dist = (pageX - slider.offsetLeft) - startX;
    slider.scrollLeft = scrollLeft - dist;
  };

  const startMo = (e) => {
    isDown = true;
    slider.classList.add('active');
    const pageX = e.pageX || e.touches[0].pageX;
    startX = pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const moveMo = (e) => {
    if (!isDown) return;
    const pageX = e.pageX || e.touches[0].pageX;
    const dist = (pageX - slider.offsetLeft) - startX;
    slider.scrollLeft = scrollLeft - dist;
  };

  // Agregar eventos solo cuando el documento está listo
  (() => {
    // Eventos para escritorio (mouse)
    slider.addEventListener('mousedown', start);
    slider.addEventListener('mousemove', move);
    slider.addEventListener('mouseup', end);
    slider.addEventListener('mouseleave', end);

    // Eventos para dispositivos móviles (touch)
    slider.addEventListener('touchstart', startMo); // Evita el scroll nativo al iniciar
    slider.addEventListener('touchmove', moveMo); // Prevenir el scroll mientras arrastras
    slider.addEventListener('touchend', end);
  })();
}

  function crossIconModal() {
    const crossIcons = document.querySelectorAll("#gallery-section__grid-images-selected span");
    const mainZoomContainer = document.querySelector('.slide-zoom-image');
    [...crossIcons].forEach((crossIcon) => {
      crossIcon.addEventListener('click', () => {
        let crossIconIndex = parseInt(crossIcon.dataset.index);
        mainZoomContainer.classList.add('active');
        document.body.style.overflow = 'hidden';
        filterCarouselImages(crossIcon.dataset.colorSelected, crossIconIndex);
      });
    })
  }

  function filterCarouselImages(color, slideIndex) {
    const galleryImages = document.querySelectorAll(".gallery-section__images-grid_item");
    const carouselContainer = document.querySelector('.slide-zoom-image_container');

    const filteredImages = [...galleryImages].filter((image) => {
      return image.classList.contains('images-selected');
    });

    carouselContainer.innerHTML = '';


    filteredImages.forEach((image) => {
      let imageCarousel = generateHtmlZoomImg(image.children[1].getAttribute('src'), image.children[1].getAttribute('srcset'));
      carouselContainer.appendChild(imageCarousel);
    })
    const featured_image = generateHtmlZoomImg(document.querySelector('.featured-image-rebuild').dataset.modalImg);
    carouselContainer.appendChild(featured_image);

    $(document).ready(function () {
      $(carouselContainer).slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
      });
      $(carouselContainer).slick('slickGoTo', slideIndex);
    });
    openCloseModal('.close-zoom-image', '.slide-zoom-image', carouselContainer);
  }

  const externalImage = document.querySelector('.cross-slick-modal');
  externalImage && externalImage.addEventListener('click', (event) => {
    const gridImagesContainer = document.querySelectorAll(".gallery-section__images-grid_item");
    const filteredImages = [...gridImagesContainer].filter((image) => {
      return image.classList.contains('images-selected');
    });

    const mainZoomContainer = document.querySelector('.slide-zoom-image');
    mainZoomContainer.classList.add('active');
    document.body.style.overflow = 'hidden';
    const colorSelected = document.querySelector('.color-selected').dataset.colorSelected.replace(/ /g, '-').toLowerCase();

    filterCarouselImages(colorSelected, filteredImages.length);
  });
  function initProductVariants() {
    variantColorEls.forEach(variantColorEl => variantColorEl.addEventListener('click', handleClick));
    variantSizeEls.forEach(variantSizeEl => variantSizeEl.addEventListener('click', handleClick));

  }

  function accordions() {
    const accordion = document.querySelectorAll('.accordion-pdp');
    [...accordion].forEach((singleAccordion, index) => {
      singleAccordion.addEventListener('click', () => {
        singleAccordion.classList.toggle('active-pdp');
        const panel = singleAccordion.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });

      // Set the first accordion as active
      if (index === 0) {
        singleAccordion.classList.add('active-pdp');
        const panel = singleAccordion.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  function addRemoveClass(optionName, selected, active) {
    let container = document.querySelectorAll(optionName);
    [...container].forEach(item => {
      item.classList.remove(active);
    });
    selected.classList.add(active)
  }
  function UpdatePriceVariant(items, price) {
    let container = document.querySelectorAll(items);

    [...container].forEach(item => {
      return item.innerHTML = `${window.currencySymbol}${(price / 100).toFixed(2)}`;
    });
  }
  function cutTheTextContent(textContent) {
    var decimal = /^[+-]?\d+(\.\d+)?$/;
    if (textContent.includes('/')) return textContent;
    if (textContent.includes('$')) return textContent.slice(0, -3);
    if (decimal.test(textContent)) return textContent;
    return textContent.replace(/[^A-Z]/g, '')
  }

  function removeAccordionEmpty() {
    [...document.querySelectorAll('.accordion-content')].forEach(item => {
      if ([...item.children].length == 0) {
        item.classList.add('dn-i')
      }
    })
  }
  function galleryNosto() {
    let nosto2 = document.querySelector('.nosto-widgets');
    const nostoDesk = document.querySelector('.product-baseline-media');
    const nostoMob = document.querySelector('.nosto--mobile-wigets');

    if (window.innerWidth > 1024) return nosto2 && nostoDesk.append(nosto2);
    if (window.innerWidth < 1024) return nosto2 && nostoMob.append(nosto2);
  }
  //Resize the grid gallery on mobile Rebuild 3
  const mainContainer = '.main-container-pdp-rebuild3';
  const rebuildGridContainer = '.rebuild3-mobile-grid-container';
  const gridContainer = '.gallery-resize-container-rebuild';
  const draggableContainer = '.info-container-draggable';

  function renderMobileDraggable(container) {
    const mainContainer = document.querySelector(container);
    if (window.innerWidth < 768) {
      mainContainer.classList.add('rebuild3-mobile-grid-container');
    } else {
      mainContainer.classList.remove('rebuild3-mobile-grid-container');
    }
    resizeContainerMobile(rebuildGridContainer, true);
    resizeContainerMobile(gridContainer, false);
    resizeContainerMobile(draggableContainer, true);
    draggableMobile(draggableContainer);

  }

  function resizeContainerMobile(container, main) {
    const rebuildGrid = document.querySelector(container);
    if (window.innerWidth < 768) {
      if (main) rebuildGrid.style.height = `${window.innerHeight}px`;
      else rebuildGrid.style.height = `${window.innerHeight - 400}px`;
    }
  }
  function draggableMobile(container) {
    var containerElement = document.querySelector(container);
    const buttonDrag = document.querySelector('.button-draggable')
    const iconsFavShad = document.querySelector('.product-form__icons-ingrid');

    var isDragging = false;
    var initialY = 0;
    var offsetY = 0;
    if (window.innerWidth < 768) {
      function handleTouchMove(e) {
        if (!isDragging) return;
        e.preventDefault();

        var touchLocation = e.targetTouches[0];
        var newY = touchLocation.pageY - offsetY;

        const rect1 = document.querySelector(gridContainer)
        var deltaY = touchLocation.pageY - initialY;

        containerElement.classList.add('absolute-i');
        containerElement.style.top = newY + 'px';
        containerElement.style.transition = 'top 0.3s ease-out';

        if (parseInt(containerElement.style.top) < 4) {
          containerElement.style.top = '5px';
          iconsFavShad.style.position = 'absolute';
          return false;
        }

        if (parseInt(containerElement.style.top) > parseInt(rect1.style.height) && deltaY) containerElement.style.top = parseInt(rect1.style.height) + 'px';
        iconsFavShad.style.position = 'fixed';
      }

      function handleTouchStart(e) {
        var touchLocation = e.targetTouches[0];
        isDragging = true;
        initialY = touchLocation.pageY;
        offsetY = touchLocation.pageY - containerElement.offsetTop;
        containerElement.style.overflow = 'auto';
      }

      function handleTouchEnd() {
        isDragging = false;
      }
      const removeOverflow = document.querySelector(mainContainer);
      removeOverflow.style.overflow = 'hidden';
      removeOverflow.addEventListener('touchmove', function (e) {
        if (e.target === removeOverflow) {
          e.preventDefault();
        }
      }, { passive: false });

      buttonDrag.addEventListener('touchstart', handleTouchStart);
      buttonDrag.addEventListener('touchmove', handleTouchMove);
      buttonDrag.addEventListener('touchend', handleTouchEnd);
    } else {
      containerElement.classList.remove('absolute-i');
      containerElement.style.overflow = 'unset';
    }

  }
  if (!addToCartBtn) return;

  initProductVariants();

  setDefaultVariant();
  accordions();
  removeAccordionEmpty();
  if (templateName === 'rebuild-1') galleryNosto();

  //ZoomImagePopup(variantSeletedImg, '.popup-container', '.popup', "#popup-image-zoom", 'active' );

  if (templateName === 'rebuild-1') window.addEventListener("resize", galleryNosto);
  // Call the resizeContainers function to set the initial container heights
  if (templateName === 'rebuild-3') {
    crossIconModal();
    if (window.innerWidth < 768) renderMobileDraggable(mainContainer)
    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) renderMobileDraggable(mainContainer)
    });
  }
  addToCartBtn.addEventListener('click', addToCartClickHandler);


  const productBundleCarousels = document.querySelectorAll('.bundles-carousel');

  productBundleCarousels.forEach(productBundleCarouselItem => {
    if (productBundleCarouselItem.querySelector('.carousel-section__bundles')) {
      let responsive = [];
      let slidesToShow = 1;

      if (productBundleCarouselItem.querySelector('.carousel-section__bundles').dataset.type == "gallery") {
        responsive = [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              adaptiveHeight: true,
            }
          }];
        slidesToShow = 3;
      }

      $(productBundleCarouselItem.querySelector('.carousel-section__bundles')).slick({
        infinite: true,
        speed: 500,
        adaptiveHeight: true,
        prevArrow: productBundleCarouselItem.querySelector('.slick-prev'),
        nextArrow: productBundleCarouselItem.querySelector('.slick-next'),
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        responsive: responsive
      });
    }
  });

})();

//utility functions
function waitForElement(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    const observer = new MutationObserver(mutations => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

//modal size 
function openCloseModalG(modal, action) {
  const sizeChart = document.querySelector(modal);
  if (action) sizeChart.classList.add('size-chart-show')
  if (!action) sizeChart.classList.remove('size-chart-show')
}

function hideElementOnEsc(elementSelector, keyCode, classNameToAdd, isAdd, carousel) {
  const element = document.querySelector(elementSelector);

  if (!element) {
    console.error(`Element not found with selector: ${elementSelector}`);
    return;
  }

  document.addEventListener('keydown', function (event) {
    if (event.keyCode === keyCode) {
      if (!element.classList.contains(classNameToAdd && isAdd)) {
        if (isAdd) element.classList.add(classNameToAdd);
        document.querySelector('body').style.overflow = 'auto';
      }

      if (element.classList.contains(classNameToAdd) && !isAdd) {
        element.classList.remove(classNameToAdd);
        document.querySelector('body').style.overflow = 'auto';
        if ($(carousel).hasClass('slick-initialized')) {
          $(carousel).slick('unslick');
        }
      }

    }
  });
}

waitForElement('.container-infinite').then((elm) => {
  hideElementOnEsc('.container-infinite', 27, 'dn-i', true);
});
waitForElement('.slide-zoom-image').then((elm) => {
  hideElementOnEsc('.slide-zoom-image', 27, 'active', false, document.querySelector('.slide-zoom-image_container'));
});

waitForElement('.size-chart-acf__modal').then((elm) => {
  hideElementOnEsc('.size-chart-acf__modal', 27, 'dn-i', true);
  elm.removeEventListener('animationend', handleAnimationEnd);
});
